<template>
  <div>
    <div class="card-container">
      <div class="card-title">
        运营数据筛选
      </div>
      <div class="card-content">
        <a-form ref="detailForm" class="detail-form" :form="form">
          <a-row>
            <!-- <a-col class="search-item" :span="5">
              <a-radio-group
                v-model="type"
                class="group-radio"
                @change="changeType"
              >
                <a-radio-button value="0">
                  总计
                </a-radio-button>
                <a-radio-button value="1">
                  最近3天
                </a-radio-button>
                <a-radio-button value="2">
                  最近7天
                </a-radio-button>
              </a-radio-group>
            </a-col> -->
            <a-col class="search-item" :span="6">
              <a-form-item label="区域" v-bind="formItemLayout">
                <a-cascader
                  v-model="region"
                  :options="options"
                  :load-data="loadData"
                  change-on-select
                  :field-names="{
                    label: 'name',
                    value: 'id',
                    children: 'children'
                  }"
                  placeholder="省市区、街道"
                  @change="changeArea"
                />
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="6">
              <a-form-item label="小区" v-bind="formItemLayout">
                <a-select
                  v-decorator="['estateId']"
                  allow-clear
                  show-search
                  placeholder="全部"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="(item, index) in estateList"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.housingEstate }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="4" align="right">
              <a-button type="primary" class="mr8" @click="toSearch">
                查询
              </a-button>
              <a-button @click="resetForm">
                重置
              </a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </div>
    <div class="card-container">
      <div class="card-content">
        <a-row class="panel-container">
          <a-col :span="4" class="height-90">
            <a-row
              style="flex-direction: column;" type="flex" align="middle"
              justify="center"
            >
              <span>
                <IconFont
                  type="iconchaping"
                  style="font-size: 30px; margin-right: 10px;"
                />
                <div class="type-name">
                  点位差评总数
                </div>
                <div class="type-num" :title="boardData.device">
                  {{ boardData.device || 0 }}
                </div>
              </span>
            </a-row>
          </a-col>
          <a-col :span="1">
          </a-col>
          <a-col :span="4" class="height-90">
            <a-row
              style="flex-direction: column;" type="flex" align="middle"
              justify="center"
            >
              <span>
                <IconFont
                  type="iconjiankang"
                  style="font-size: 30px; margin-right: 10px;"
                />
                <div class="type-name">
                  点位问题设备总数
                </div>
                <div class="type-num" :title="boardData.health">
                  {{ boardData.health || 0 }}
                </div>
              </span>
            </a-row>
          </a-col>
          <a-col :span="1">
          </a-col>
          <a-col :span="4" class="height-90">
            <a-row
              style="flex-direction: column;" type="flex" align="middle"
              justify="center"
            >
              <span>
                <IconFont
                  type="iconhuanjing"
                  style="font-size: 30px; margin-right: 10px;"
                />
                <div class="type-name">
                  点位内环境不合格总数
                </div>
                <div class="type-num" :title="boardData.innerScore">
                  {{ boardData.innerScore || 0 }}
                </div>
              </span>
            </a-row>
          </a-col>
          <a-col :span="1">
          </a-col>
          <a-col :span="4" class="height-90">
            <a-row
              style="flex-direction: column;" type="flex" align="middle"
              justify="center"
            >
              <span>
                <IconFont
                  type="iconwaihuanjing"
                  style="font-size: 30px; margin-right: 10px;"
                />
                <div class="type-name">
                  点位外环境不合格总数
                </div>
                <div class="type-num" :title="boardData.outerScore">
                  {{ boardData.outerScore || 0 }}
                </div>
              </span>
            </a-row>
          </a-col>
          <a-col :span="1">
          </a-col>
          <a-col :span="4" class="height-90">
            <a-row
              style="flex-direction: column;" type="flex" align="middle"
              justify="center"
            >
              <span>
                <IconFont
                  type="iconyiwei"
                  style="font-size: 30px; margin-right: 10px;"
                />
                <div class="type-name">
                  点位气味不达标总数
                </div>
                <div class="type-num" :title="boardData.smell">
                  {{ boardData.smell || 0 }}
                </div>
              </span>
            </a-row>
          </a-col>
        </a-row>
      </div>
    </div>
    <div class="card-container mrt16">
      <a-row>
        <a-col :span="12">
          <div class="card-title">
            运营数据分析列表
          </div>
        </a-col>
      </a-row>
      <div class="card-content">
        <a-table
          class="table-content"
          :columns="columns"
          :data-source="formData"
          :loading="loading"
          :pagination="pagination"
          :row-key="record => record.productId"
          :scroll="{ x: 1500 }"
          @change="handleTableChange"
        >
          <template slot="scenario" slot-scope="text">
            <span>{{ text | scenarioFl }}</span>
          </template>
          <div slot="action" slot-scope="record" class="btn-list">
            <a-button
              v-action:getscoredetail
              class="table-btn-link"
              type="link"
              size="small"
              @click="toView(record)"
            >
              查看详情
            </a-button>
          </div>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import {
  getArea,
  getEstate,
  iconFontComponent
} from '@/components/mixins/mixins.js'
import { getScoreList } from '@/api/statistics'
const columns = [
  {
    title: '区域名称',
    dataIndex: 'areaName'
  },
  {
    title: '设备名称',
    dataIndex: 'name'
  },
  {
    title: '街道名称',
    dataIndex: 'street'
  },
  {
    title: '小区名称',
    dataIndex: 'estateName'
  },

  {
    title: '设备类型',
    dataIndex: 'scenario',
    scopedSlots: { customRender: 'scenario' }
  },
  {
    title: '设备编号',
    dataIndex: 'productId'
  },
  {
    title: '最新运营评分',
    dataIndex: 'device',
    customRender (text, record, index) {
      if (text) {
        return text + '分'
      } else {
        return '-'
      }
    },
    sorter: true
  },
  {
    title: '最新外环境评分',
    dataIndex: 'outerScore',
    customRender (text, record, index) {
      if (text) {
        return text + '分'
      } else {
        return '-'
      }
    },
    sorter: true
  },
  {
    title: '最新内环境评分',
    dataIndex: 'innerScore',
    customRender (text, record, index) {
      if (text) {
        return text + '分'
      } else {
        return '-'
      }
    },
    sorter: true
  },
  {
    title: '最新健康评分',
    dataIndex: 'health',
    customRender (text, record, index) {
      if (text) {
        return text + '分'
      } else {
        return '-'
      }
    },
    sorter: true
  },
  {
    title: '最新异味评分',
    dataIndex: 'smell',
    customRender (text, record, index) {
      if (text) {
        return text + '分'
      } else {
        return '-'
      }
    },
    sorter: true
  },
  {
    title: '操作',
    key: 'operation',
    fixed: 'right',
    width: 120,
    scopedSlots: { customRender: 'action' }
  }
]
export default {
  mixins: [getArea, getEstate, iconFontComponent],
  data () {
    return {
      detialVisible: false,
      loading: false,
      detialList: [],
      detialLoading: false,
      type: '0',
      showtime: [],
      region: [],
      options: [],
      formData: [],
      columns,
      boardData: {},
      form: this.$form.createForm(this, {}),
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      },
      pagination: {
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => '共' + total + '条记录',
        pageSizeOptions: ['10', '20', '30', '40'],
        defaultPageSize: 10,
        total: 0
      },
      rowFlag: null,
      rowText: null
    }
  },
  created: function () {
    this.handleQuery()
  },
  mounted: function () {
    this.load()
  },
  methods: {
    toView (record) {
      console.log('哈哈哈')
      this.$router.push({
        path: '/finance/plotDeviceNew/view',
        query: { info: JSON.stringify(record) }
      })
    },
    handleOk (e) {
      console.log(e)
      this.detialVisible = false
    },
    load () {
      this.getArea('', 2)
      this.getEstate()
      this.getTable()
    },
    getTable () {
      const params = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        provinceId: this.region[0] || '',
        cityId: this.region[1] || '',
        areaId: this.region[2] || '',
        estateId: this.form.getFieldValue('estateId')
      }
      params.streetId = this.region[3] || ''
      /* if (this.type !== '') {
        params.type = Number(this.type)
      } */
      this.loading = true
      getScoreList(params).then(res => {
        this.loading = false
        const result = res.result
        this.formData = result.list
        this.boardData = result
        this.pagination.total = result.totalCount
      })
    },
    /* changeType () {
      this.getTable()
    }, */
    changeArea (areasId) {
      this.estateList = []
      this.form.setFieldsValue({ estateId: undefined })
      if (areasId.length < 4) {
        this.getEstate(areasId)
      } else if (areasId.length === 4) {
        this.getEstate(null, areasId[3])
      }
    },
    toSearch () {
      this.pagination.current = 1
      this.getTable()
    },
    resetForm () {
      this.form.resetFields()
      // this.type = '0'
      this.region = []
      this.form.setFieldsValue({ estateId: undefined })
      this.getTable()
      this.getEstate()
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    handleTableChange (pagination, filters, sorter) {
      const pager = { ...this.pagination }
      pager.current = pagination.current
      pager.pageSize = pagination.pageSize
      this.pagination = pager
      this.getTable()
    },
    handleQuery () {
      const status = this.$route.query.status || ''
      if (status === 'today') {
        this.showtime = [moment(), moment()]
        this.type = ''
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.card-container
  .card-title
    span
      font-weight normal
      margin-left 30px
      font-size 14px
.panel-container
  // margin-top 8px
  margin-bottom 25px
.height-90
  height 90px
  position relative
  &.large
    width 18%
  &:not(:last-child)::after
    position absolute
    right 0
    top 50%
    transform translateY(-50%)
    content ''
    display block
    width 1px
    height 58px
    background-color #e8e8e8
  &.data
    background-color #F4F5F7
    border-radius 4px
    &::after
      width 0
      height 0
  .type-name
    color #666666
    font-size 12px
    margin-top 16px
    display flex
    align-items center
    // justify-content center
    // text-align center
    .type-icon
      width 8px
      height 8px
      border-radius 4px
      // margin-right 5px
  .type-num
    font-size 24px
    color #333333
    margin-top 8px
    text-align left
</style>
